import {elementFrom} from "../../../common/utils/html";
import {UnLitElement} from "../../../common/elements";
import {DialogOpener} from "./dialogOpener";
import type {DialogAnchor} from "./dialogAnchor";
import {property} from "lit/decorators.js";

export abstract class DialogAnchorTemplateContent extends UnLitElement implements DialogAnchor {

    @property({attribute: "disable-close-on-outside-click", type: Boolean})
    public disableCloseOnOutsideClick: boolean = false;

    private dialogOpener: DialogOpener;
    protected dialogContent: HTMLElement;

    public connectedCallback(): void {
        super.connectedCallback();

        const dialogTemplate = this.resolveTemplateElement("content");

        if (!dialogTemplate) {
            return;
        }

        const dialogHtml = dialogTemplate.innerHTML;
        this.dialogContent = elementFrom<HTMLElement>(dialogHtml);
        this.dialogOpener = new DialogOpener(this.dialogContent, this, this.disableCloseOnOutsideClick);
    }

    public openDialog(e: Event): void {
        this.dialogOpener.openDialog(e);
    }
}
